import MapArtist from '../../MapArtist/MapArtist'
import React from 'react';


      

const Artistess = (props) => {

         return( props.newArray.length > 0 &&
        <div>

            <div className="container-fluid">
                <div className="row justify-content-md-center">
                    <MapArtist MesCards={props.newArray} />
                </div>
            </div>

        </div>
        )   
        
        
}

export default Artistess;




